import { render } from "./product-recommanded.vue?vue&type=template&id=46a94c70&scoped=true"
import script from "./product-recommanded.vue?vue&type=script&lang=js"
export * from "./product-recommanded.vue?vue&type=script&lang=js"

import "./product-recommanded.vue?vue&type=style&index=0&id=46a94c70&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a94c70"]])

export default __exports__